import Dataset from "./Dataset";

export default class Sites extends Dataset {
  type = "feature";
}
